import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ContentContainer } from "pstat-anywhere/components/pages";
import AdvancedReportPage from "pstat-anywhere/components/pages/reports/AdvancedReportPage";
import unpublishTemplate from "pstat-anywhere/components/system_document_templates/UnpublishTemplateMutation";
import { useLabels } from "pstat-anywhere/context_providers/LabelContext";
import { getRootUrl } from "pstat-anywhere/utils/urls";
import { SuccessBanner } from "pstat-design-system/banner";
import Breadcrumb from "pstat-design-system/Breadcrumb";

const TemplateManagementBreadcrumb = () => {
  const { t } = useTranslation();
  const labels = useLabels();
  const { documentLabel } = labels;
  return (
    <Breadcrumb
      text={t("systemDocumentTemplates.header", { documentLabel })}
      to={`${getRootUrl()}/template/manage`}
    />
  );
};

const SuccessfullyUnpublishedBanner = ({ templateName, sitesCount }) => {
  const { t } = useTranslation();
  const messageId =
    sitesCount === 1
      ? "systemDocumentTemplates.manage.sites.unpublishSuccess"
      : "systemDocumentTemplates.manage.sites.unpublishSuccessPlural";
  const message = t(messageId, { templateName, sitesCount });
  return <SuccessBanner message={message} width={null} mx={4} mt={6} />;
};

const PublishedTemplatesPage = ({
  adoptedSystemDocumentTemplates,
  variables,
  location,
  route,
  router
}) => {
  const [showSuccessUnpublishBanner, setShowSuccessUnpublishBanner] = useState(
    false
  );
  const { t } = useTranslation();
  const [unpublishTemplateName, setUnpublishTemplateName] = useState("");
  const [numBlocUnpublishTemplates, setNumBlocUnpublishTemplates] = useState(0);

  const onSuccessUnpublish = (templateName, numBlocs) => {
    setShowSuccessUnpublishBanner(true);
    setUnpublishTemplateName(templateName);
    setNumBlocUnpublishTemplates(numBlocs);
  };

  const unpublishTemplateHandler = (templateId, templateName) => {
    unpublishTemplate(templateId, location, (data, errors) => {
      const { unpublishSystemDocumentTemplate } = data || {};
      if (unpublishSystemDocumentTemplate.ok) {
        const { unpublish_success } =
          unpublishSystemDocumentTemplate?.result || {};
        onSuccessUnpublish(templateName, (unpublish_success || []).length);
      }
    });
  };
  const templates =
    adoptedSystemDocumentTemplates?.adoptedSystemDocumentTemplates;
  const edges = templates?.edges;

  const dataWithUnpublishHandler = (edges || [])
    .map(item => item.node)
    .map(item => Object.assign({ unpublishTemplateHandler }, item))
    .map(item => ({ node: item }));

  const data = {
    edges: dataWithUnpublishHandler,
    totalCount: templates?.totalCount
  };
  const tabs = [
    {
      id: "system_templates_published",
      textKey: "systemDocumentTemplates.published.tab",
      path: ""
    }
  ];
  return (
    <ContentContainer>
      {showSuccessUnpublishBanner && (
        <SuccessfullyUnpublishedBanner
          sitesCount={numBlocUnpublishTemplates}
          templateName={unpublishTemplateName}
        />
      )}
      <AdvancedReportPage
        variables={variables}
        data={data}
        tabs={tabs}
        route={route}
        router={router}
        location={location}
        headerText={t("systemDocumentTemplates.published.header")}
        noContentMessage={t("systemDocumentTemplates.emptyMessage")}
        showTabsPanel={true}
        tableType="publishedTemplatesTable"
        customOnRow={() => {}}
        showActionButtonPanel={true}
        frozenColumnTable={true}
        BreadcrumbComponent={TemplateManagementBreadcrumb}
      />
    </ContentContainer>
  );
};

export default PublishedTemplatesPage;
